import { useEffect, useState } from 'react';
import { getOiReferences } from '../services/locationService';

const referenceLabel = (reference: any) =>
  reference?.reference_number || reference?.title || reference?.name || reference?.reference || reference?.oi_reference;

export default function useOiReferenceLabels(enabled = true) {
  const [references, setReferences] = useState<any[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    getOiReferences()
      .then((response) => {
        const options = Array.isArray(response) ? response : (response?.data?.data ?? response?.data ?? []);
        if (active) setReferences(Array.isArray(options) ? options : []);
      })
      .catch((error) => console.error('Failed to load OI reference labels:', error));
    return () => {
      active = false;
    };
  }, [enabled]);

  return (item: any): string => {
    const embedded = Array.isArray(item.oi_references) ? item.oi_references : item.oi_reference ? [item.oi_reference] : [];
    const selected = Array.isArray(item.oi_reference_ids)
      ? item.oi_reference_ids
      : item.oi_reference_id != null
        ? [item.oi_reference_id]
        : embedded;

    return (
      selected
        .map((value: any) => {
          const id = typeof value === 'object' ? value?.id : value;
          const reference = references.find((option) => String(option.id) === String(id));
          const savedReference = embedded.find((option: any) => String(option?.id) === String(id));
          return referenceLabel(reference) || referenceLabel(savedReference) || referenceLabel(value) || id;
        })
        .filter((value: any) => value != null && value !== '')
        .join(', ') || 'N/A'
    );
  };
}
